import { MEDIA } from '@/assets/media';
import { useContent } from '@/content/ContentContext';
import { Signature } from '@/ui/Brand/Signature';
import { Wordmark } from '@/ui/Brand/Wordmark';
import { ButtonLink } from '@/ui/Button/Button';
import { Container } from '@/ui/Layout/Container';

import styles from './SiteFooter.module.css';

/**
 * Chapitre 07, l'horizon : le dernier trou noir, vu de face, dessine un anneau
 * de lumière autour du monogramme. Fin du voyage, début du projet.
 */
export function SiteFooter() {
  const { footer } = useContent();

  return (
    <footer id="horizon" className={styles.footer} data-cosmos-chapter="horizon">
      <div className={styles.horizon} aria-hidden="true" data-cosmos-decor />
      <Container className={styles.inner}>
        <div className={styles.mark}>
          <img
            src={MEDIA.monogram.src}
            width={MEDIA.monogram.width}
            height={MEDIA.monogram.height}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>
        <Wordmark className={styles.wordmark} />
        <p className={styles.tagline}>{footer.tagline}</p>
        <ButtonLink className={styles.cta} href={footer.cta.href}>
          {footer.cta.label}
        </ButtonLink>
        <Signature className={styles.signature} words={footer.signature} />
      </Container>
      <Container className={styles.bottom}>
        <span>{footer.copyright}</span>
        <nav className={styles.legal} aria-label="Liens secondaires">
          {footer.legal.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>
      </Container>
    </footer>
  );
}
